 //const API_BASE_URL = 'http://localhost:3000/api/';

 const API_BASE_URL = 'https://testing.dfivetechnologies.com/api/';
export default API_BASE_URL;


// const API_BASE_URL = 'https://testing.dfivetechnologies.com/api/';